import React from 'react';
import { useTypewriter } from 'react-simple-typewriter';
import { Link } from 'react-router-dom';
import Popular from './Popular';

const Main = () => {

  const [typeEffect] = useTypewriter({
    words: ['Welcome to ItxSahil(Sahil Jogi) Website!', 'You can see amazing projects in Explore!', 'Have a Great Day!'],
    loop:{},
    typeSpeed: 100,
    delaySpeed: 30
  })

  return (
    <>
      <div className='main' style={{ display: 'flex', alignItems: 'center', backgroundColor: 'white', flexDirection: 'column' }}>
        <div className='left' style={{ width: '100%', height: '50vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <div className='shape mx-3' style={{   
            width: '60%',
            maxWidth: '520px',
            height: 'auto',
            backgroundColor: '#efefef',
            borderRadius: '30% 50% 30% 50% / 60% 40% 60% 40%',
            padding: '20px',
            marginTop: '30px'
          }}>
            <h1 style={{ fontWeight: '800', textAlign: 'center' }}><code>{typeEffect}</code></h1>
          </div>
          <Link className="btn btn-outline-primary" to="/ex" style={{ marginTop: '25px' }}><b>Explore</b></Link>
        </div>
        <div className='right' style={{ width: '100%', height: '47vh', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img alt='Not found' src='https://th.bing.com/th/id/R.5528c531364320aa5bb3ad95d4c9c99e?rik=0x%2fs0y2Qb0YBIw&pid=ImgRaw&r=0' style={{ maxHeight: '100%', maxWidth: '100%' }}></img>
        </div>
      </div>
      <Popular />
    </>
  )
}

export default Main;
